( function () {
	'use strict';

	/* eslint max-params:0 */
	function CopyTemplateModalCtrl ( logger, templateModel, $modalInstance, _, Session, apiService ) {
		var self        = this;
		var credentials = Session.getCredentials();

		self.copyTemplateName = 'Copy of ' + templateModel.name;

		var errorMsg = {
			'maxlength' : 'Template name exceeds character limit',
			'required'  : 'Template name is required.'
		};

		function apiSave () {
			// this just  a temporary solution
			return apiService.copyTemplate
				.get( {
					'userId'      : credentials.userId,
					'templateId'  : templateModel.id,
					'recipientId' : credentials.userId
				}, templateModel,
				function ( copyTemplateResult ) {
					// add default name
					copyTemplateResult.name = self.copyTemplateName;

					copyTemplateResult = _.omit( copyTemplateResult, 'templateName', 'dateCreated', 'defaultSearch', 'isFave', 'locked', 'version' );

					apiService.templates
						.update( {
							'userId'     : credentials.userId,
							'templateId' : copyTemplateResult.id
						}, copyTemplateResult,
						function ( newTemplate ) {
							logger.notifySuccess( 'Successfully Copied!', 'Template' );
							self.loading = false;
							$modalInstance.close( newTemplate );
						} );
				} );
		}

		function cancel () {
			$modalInstance.dismiss();
		}

		function copyTemplate ( error ) {
			if ( _.isEmpty( error ) ) {
				self.loading = true;
				return self.apiSave();
			}
			self.error = true;
			logger.notifyError( errorMsg[ _.keys( error )[ 0 ] ] );
		}

		function activate () {
			logger.info( 'Activated Copy Template Modal Controller' );
		}

		activate();

		self.cancel       = cancel;
		self.copyTemplate = copyTemplate;
		self.apiSave      = apiSave;
	}

	angular
		.module( 'app.components' )
		.controller( 'CopyTemplateModalCtrl', CopyTemplateModalCtrl );

	CopyTemplateModalCtrl.$inject = [ 'logger', 'templateModel', '$modalInstance', '_', 'Session', 'apiService' ];
} )( );
